import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: false, loading: false, data: [],total:0,error: "", message: "" }

export const clearPostBackAction = createAsyncThunk(
    'clear-postback-log',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/clear/postback/`,data )
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const clearPostbackSlice = createSlice({
    name: 'clear-postback-log',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(clearPostBackAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(clearPostBackAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(clearPostBackAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message

            })
        },

})



export const clearPostBackReducer = clearPostbackSlice.reducer